import { render, staticRenderFns } from "./TopCountsPanel.vue?vue&type=template&id=0ff843c0&scoped=true&"
import script from "./TopCountsPanel.vue?vue&type=script&lang=js&"
export * from "./TopCountsPanel.vue?vue&type=script&lang=js&"
import style0 from "./TopCountsPanel.vue?vue&type=style&index=0&id=0ff843c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff843c0",
  null
  
)

export default component.exports